import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { POST } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// Create Comment
export const CreateComment = createAsyncThunk(
  "/website/comments/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Comment.comments, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "comments",
  initialState: {
    data: null,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {
    resetCommentState: (state) => {
      state.data = null;
      state.status = IDS.SLICESTATUS.Idle;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateComment.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateComment.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
      })
      .addCase(CreateComment.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const { resetCommentState } = Slice.actions;
export default Slice.reducer;
